<mat-form-field [ngClass]="class">
  <input type="number" matInput [formControl]="controlFC" [id]="labelId" [readonly]="readonly"
    [min]="minValue" [max]="maxValue" [step]="step"/>
  @if (unitList.length === 1) {
    <span matSuffix>{{ unitControlFG.valueFC.value }}</span>
  }
  @if (unitList.length > 1) {
    <mat-select matSuffix [formControl]="unitKeyFC" [compareWith]="compareByKey" class="width-150px">
      @for (type of unitList; track type) {
        <mat-option [value]="type" class="mat-option-suffix">
          {{ type.value }}
        </mat-option>
      }
    </mat-select>
  }
  <mat-hint>{{ hint }}</mat-hint>
  @if (showErrors && controlFC.hasError('required')) {
    <mat-error>{{ 'REQUIRED_FIELD' | translate }}</mat-error>
  }
  @if (showErrors && controlFC.hasError('min')) {
    <mat-error>Minimum value is {{minValue}}</mat-error>
  }
  @if (showErrors && controlFC.hasError('max')) {
    <mat-error>Maximum value is {{maxValue}}</mat-error>
  }
</mat-form-field>